var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v(" Для того аби скористатися сервісом потібрно "),_c('router-link',{attrs:{"to":{ name: 'my-profile', params: { tab: 'verification' } }}},[_vm._v(" верифікувати аккаунт")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }